const html = `
    <div class="footer-links">
        <div class="footer-links-col ___desktop-50">
            <div class="footer-logos-info">
                <h2 class="screen-reader-text">Colofon</h2>
                "CHA" is ontwikkeld door het ministerie van Gezondheid, Milieu en Natuur (GMN).
                Deze applicatie was snel tot stand gekomen met behulp van tientallen experts en
                ervaringsdeskundigen. Ook heeft een grote open source community
                tijdens de ontwikkeling meegekeken en getest.
            </div>
        </div>
        <div class="footer-links-col ___desktop-50">
            <h2>Heb je vragen over "CHA"?<br>
            Neem contact met ons op
            </h2>
            <h3>Bel de helpdesk</h3>
            <p><a href="tel:08001421">433-3111</a><br />
            Bereikbaar van maandag t/m vrijdag van 08.00 – 15.00 uur</p>
            <h3>Of stuur een e-mail naar:</h3>
            <p>
                <a href="mailto:helpdesk@curacaohealthapp.cw" target="_blank" rel="noopener noreferrer">helpdesk@curacaohealthapp.com</a>
            </p>
        </div>
        <div style="position: relative;height:400px;width: 300px;">
            <div style="margin: 0;position:absolute; top:50%;left: 50%;">
                <img style="alignment: right;" src="assets/img/artwork/CHA_app_Graphics-16.png" width=182 height=100 />
            </div>
        </div>
    </div>
`;

export default html
